import React from 'react';
import { ArrowRight, CheckCircle2, LockKeyhole } from 'lucide-react';
import { STATES } from '../api';
import { LinkButton } from '../ui';

export const RFQReview = ({ user, draft, form, files }) => (
  <div className="rfq-review" data-testid="rfq-review">
    <h2>Ready for the right quotation.</h2>
    <dl>
      <div><dt>Business</dt><dd data-testid="rfq-review-business">{user?.company || 'Sign in required'}</dd></div>
      <div><dt>Products</dt><dd>{draft.length} line items {form.sample && '· Sample request'}</dd></div>
      <div><dt>Deliver to</dt><dd data-testid="rfq-review-destination">{form.destination}, {form.pincode}<br />
        {STATES.find(state => state[0] === form.state_code)?.[1]}, India</dd></div>
      <div><dt>Timeline</dt><dd>{form.timeline}</dd></div>
      <div><dt>Attachments</dt><dd>{files.length ? files.map(file => file.name).join(', ') : 'None'}</dd></div>
      {form.notes && <div><dt>Requirements</dt><dd>{form.notes}</dd></div>}
    </dl>
    <div className="notice" data-testid="rfq-review-payment-notice">Each supplier receives only the products assigned to their business. No payment is collected with this request.</div>
  </div>
);

export const RFQSummary = ({ draft }) => (
  <aside className="rfq-summary">
    <span className="eyebrow">YOUR SOURCING BRIEF</span><h2>Built around your business.</h2>
    <div><span>Product lines</span><strong data-testid="rfq-line-count">{draft.length}</strong></div>
    <div><span>Suppliers</span><strong data-testid="rfq-supplier-count">{new Set(draft.map(item => item.supplier_name)).size}</strong></div>
    <div><span>Currency</span><strong>INR</strong></div>
    <p><LockKeyhole size={17} />Your specifications are shared only with the relevant supplier.</p>
    <p>Final pricing, freight and GST are included in your supplier’s quotation.</p>
  </aside>
);

export const RFQSuccess = ({ requests }) => (
  <div className="success-view" data-testid="rfq-success">
    <CheckCircle2 size={54} /><h2>Your request is on its way.</h2>
    <p>{requests.length} supplier request{requests.length !== 1 ? 's' : ''} created.</p>
    {requests.map(request => <span key={request.id} data-testid={`rfq-created-${request.id}`}>{request.number} · {request.supplier_name}</span>)}
    <LinkButton to="/workspace/rfqs" id="view-submitted-rfqs">View my requests <ArrowRight size={17} /></LinkButton>
  </div>
);